export default {
  title: 'Impressum',
  subtitle: 'Det vises først i sidefoden på din onlineshop og storefront, når du har gemt det.',
  card_title: 'Impressum',
  placeholder: 'Indtast oplysningerne til dit impressum',
  status: {
    saved: 'Gemt',
    not_shown: 'Vises endnu ikke i din shop eller storefront',
    unsaved: 'Ugemte ændringer — din shop og storefront viser den senest gemte version',
  },
  save: 'Gem',
  retry: 'Prøv igen',
  preview: {
    title: 'Forhåndsvisning af sidefod (shop og storefront)',
    terms: 'Vilkår',
    privacy: 'Privatliv',
    cookies: 'Cookies',
    imprint: 'Impressum',
  },
  toasts: {
    saved: 'Impressum gemt',
    save_failed: 'Impressum kunne ikke gemmes. Prøv igen.',
    load_failed: 'Impressum kunne ikke indlæses. Genindlæs siden.',
  },
};
